import React from 'react';
import { arrayBuilderYesNoUI } from 'platform/forms-system/src/js/web-component-patterns';
import get from 'platform/utilities/data/get';

import fullSchema from '../../../schema';
import { privateMedicalRecordsOptions } from './options';

const { arrayPath } = privateMedicalRecordsOptions;

export const RecordsWeCanReviewInfo = () => (
  <va-accordion>
    <va-accordion-item
      header="Records we can review from other healthcare providers"
      level="4"
      bordered
    >
      <p className="vads-u-margin-top--0">
        We’ll need your permission to request access to your records on your
        behalf from these other healthcare facilities:
      </p>
      <ul>
        <li>Private medical centers (non-VA)</li>
        <li>Veteran’s Choice</li>
        <li>Vet Centers</li>
        <li>Community Care providers</li>
      </ul>
    </va-accordion-item>
  </va-accordion>
);

/**
 * Shown in place of the summary cards when no items exist.
 * Placed as its own schema field, rather than in the summary page's title/description
 * text overrides, in order to render below the page's alerts/cards block.
 */
const NoProviderRecordsMessage = () => (
  <p>
    There are no records from other healthcare providers associated with this
    claim.
  </p>
);

export default {
  uiSchema: {
    'view:noProviderRecordsMessage': {
      'ui:description': NoProviderRecordsMessage,
      'ui:options': {
        hideIf: formData => !!get(arrayPath, formData)?.length,
      },
    },
    'view:hasProviderFacilities': arrayBuilderYesNoUI(
      privateMedicalRecordsOptions,
      // Reachable with no cards present: the authorize-release page's
      // `onNavForward` only skips the summary on the way in when the loop is
      // empty, so deleting the last provider (or navigating back) still
      // lands here. Mirrors the VA medical records summary's no-items vs.
      // has-items title split.
      {
        title: 'Do you have records from other healthcare providers to add?',
        errorMessages: {
          required:
            'Select yes if you have records from other healthcare providers to add',
        },
      },
      {
        title: 'Do you have records from other healthcare providers to add?',
        errorMessages: {
          required:
            'Select yes if you have records from other healthcare providers to add',
        },
      },
    ),
    'view:recordsWeCanReviewInfo': {
      'ui:description': RecordsWeCanReviewInfo,
    },
  },
  schema: {
    type: 'object',
    required: ['view:hasProviderFacilities'],
    properties: {
      'view:noProviderRecordsMessage': { type: 'object', properties: {} },
      'view:hasProviderFacilities':
        fullSchema.properties['view:hasProviderFacilities'],
      'view:recordsWeCanReviewInfo': { type: 'object', properties: {} },
    },
  },
};
